import React from 'react';
import './incompatible_browser.scss';
import { FormattedMessage } from 'react-intl';

export class IncompatibleBrowser extends React.Component<{}> {
  render() {
    const browserSupport = window.browser_support;
    const isCrawlerBot = window.is_crawler_bot; // do not display if google bot
    return (
      !isCrawlerBot &&
      browserSupport > -1 &&
      browserSupport < 2 && (
        <div
          className={`incompatible_browser incompatible_browser--0${browserSupport}`}
        >
          <p>
            <FormattedMessage id="app/incompatible-browser/IncompatibleBrowser.tsx/1" />
          </p>
          <p>
            <FormattedMessage id="app/incompatible-browser/IncompatibleBrowser.tsx/2" />{' '}
            <a
              href="https://www.google.fr/chrome/browser/desktop/"
              className="incompatible_browser__link"
            >
              <FormattedMessage id="app/incompatible-browser/IncompatibleBrowser.tsx/3" />
            </a>{' '}
            <FormattedMessage id="app/incompatible-browser/IncompatibleBrowser.tsx/4" />
          </p>
        </div>
      )
    );
  }
}
